import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ProfileComponent } from '../../auth/profile/profile.component';
import { SharedService } from '../service/shared.service';

@Injectable()
export class ProfileGuardGuard {
  private sharedSrv = inject(SharedService);

  canDeactivate(
    _component: ProfileComponent,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    _nextState?: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    /**
     * 教师角色，必须设置科目
     */
    const sharedSrv = this.sharedSrv;
    if (!sharedSrv.user) {
      // 当已经退出系统后,离开该页面
      return true;
    } else {
      // 其他条件下,离开该页面
      return (
        sharedSrv.user.is_teacher && typeof sharedSrv.user.subject_id === 'number' && sharedSrv.user.subject_id > 0
      );
    }
  }
}
